<template>
  <div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row">
      <div class="col-md-12">
        <div class="card mb-4">
          <div class="card-body">
            <div class="card-title mb-3">New parking</div>
            <fieldset class="border p-3">
              <div>
                <form @submit.prevent="newParking()">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Date</label>
                        <input
                          type="date"
                          class="form-control parking_date"
                          required
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <label>Parking month</label>
                      <select
                        name="parking_month"
                        class="form-control input_rounded parking_month"
                      >
                        <option>Select Month</option>
                        <option value="January">January</option>
                        <option value="February">February</option>
                        <option value="March">March</option>
                        <option value="April">April</option>
                        <option value="May">May</option>
                        <option value="June">June</option>
                        <option value="July">July</option>
                        <option value="August">August</option>
                        <option value="September">September</option>
                        <option value="October">October</option>
                        <option value="November">November</option>
                        <option value="December">December</option>
                      </select>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table class="table">
                          <thead>
                            <tr>
                              <th scope="col">#</th>
                              <th scope="col">Description</th>
                              <th scope="col">Truck</th>
                              <th scope="col">Unit price</th>
                              <th scope="col">Total price</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(parking_product, k) in parkingItems"
                              :key="k"
                            >
                              <td scope="row">
                                <button
                                  type="button"
                                  class="btn btn-raised btn-raised-danger btn-sm m-1"
                                  @click="deleteRow(k, parking_product)"
                                >
                                <i class="nav-icon i-Close-Window font-weight-bold"></i>
                                </button>
                                <!-- <i class="fa fa-trash-alt" @click="deleteRow(k, expense_product)"></i> -->
                              </td>
                              <td>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="parking_product.description"
                                  required
                                  readonly
                                />
                              </td>
                              <td>
                                <model-list-select
                                  :list="systemTrucks"
                                  v-model="parking_product.truck_id"
                                  option-value="id"
                                  option-text="truck_no"
                                  placeholder="select truck name"
                                ></model-list-select>
                              </td>
                              <td>
                                <input
                                  class="form-control"
                                  type="number"
                                  min="1"
                                  step=".01"
                                  @wheel="$event.target.blur()"
                                  v-model="parking_product.unit_price"
                                  @keyup="calculateLineTotal(parking_product)"
                                />
                              </td>
                              <td>
                                <input
                                  readonly
                                  class="form-control text-right"
                                  type="number"
                                  min="1"
                                  step=".01"
                                  @wheel="$event.target.blur()"
                                  v-model="parking_product.total_price"
                                />
                              </td>
                            </tr>
                          </tbody>
                          <tfoot>
                            <tr>
                              <td colspan="4" class="text-right">Sub Total</td>
                              <input
                                readonly
                                class="form-control text-right sub_total"
                                type="number"
                                min="0"
                                step=".01"
                                :value="invoice_subtotal"
                              />
                            </tr>
                            <tr>
                              <td colspan="4" class="text-right">Total</td>
                              <input
                                readonly
                                class="form-control text-right grand_total"
                                type="number"
                                min="0"
                                step=".01"
                                :value="invoice_total"
                              />
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <div class="col-md-12 mb-2">
                      <button
                        type="button"
                        class="btn btn-info"
                        @click="addParkingitems"
                      >
                        <i class="fa fa-plus-circle"></i>
                        Add
                      </button>
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary btn-flat creatingParking btn-rounded"
                    >
                      <i class="fa fa-plus"></i> create parking
                    </button>
                    <button
                      type="button"
                      class="btn-rounded btn-flat creatingParkingLoader btn-rounded"
                    >
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      <i
                        class="fa fa-spinner fa-spin"
                        style="font-size: 24px"
                      ></i>
                      please wait...
                    </button>
                  </div>
                </form>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModelListSelect } from "vue-search-select";
export default {
  data() {
    return {
      invoice_subtotal: 0.0,
      invoice_total: 0.0,
    };
  },
  created() {
    this.loadTrucks();
  },
  computed: {
    ...mapGetters(["systemTrucks", "parkingItems"]),
  },
  methods: {
    ...mapActions(["newParking", "loadTrucks"]),
    ...mapMutations(["addParkingitems"]),
    calculateTotal() {
      var subtotal, total, totals;
      subtotal = this.parkingItems.reduce(function (sum, product) {
        var lineTotal = parseFloat(product.total_price);
        if (!isNaN(lineTotal)) {
          return sum + lineTotal;
        }
      }, 0);

      if (!isNaN(subtotal)) {
        this.invoice_subtotal = subtotal.toFixed(2);
      } else {
        this.invoice_subtotal = "0.00";
      }
      total = subtotal;
      total = parseFloat(total);
      if (!isNaN(total)) {
        this.invoice_total = total.toFixed(2);
      } else {
        this.invoice_total = "0.00";
      }
    },
    calculateLineTotal(parking_product) {
      var total = parseFloat(parking_product.unit_price) * 1;
      if (!isNaN(total)) {
        parking_product.total_price = total.toFixed(2);
      }
      this.calculateTotal();
    },
    deleteRow(index, parking_product) {
      var idx = this.parkingItems.indexOf(parking_product);
      console.log(idx, index);
      if (idx > -1) {
        this.parkingItems.splice(idx, 1);
      }
      this.calculateTotal();
    },
  },
  components: {
    ModelListSelect,
  },
};
</script>
<style scoped>
.creatingParkingLoader {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/parkings/parking.vue